/**
 * Application Entry Point
 * Bootstraps the React application.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@styles/index.css';

/**
 * Initialize mock service worker in development if enabled.
 */
const initMockServer = async (): Promise<void> => {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MOCK_API === 'true') {
    const { startMockServer } = await import('@mocks/browser');
    await startMockServer();
  }
};

/**
 * Render the application.
 */
const renderApp = (): void => {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Failed to find root element. Ensure index.html contains <div id="root"></div>');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

/**
 * Bootstrap the application.
 */
initMockServer().then(renderApp);
